import { render, staticRenderFns } from "./UserKeys.vue?vue&type=template&id=0836a028"
import script from "./UserKeys.vue?vue&type=script&lang=js"
export * from "./UserKeys.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports